import React from 'react';
import { useNavigate } from 'react-router-dom';
import MainLayout from '../../../components/layout/MainLayout';
import { useLayoutContext } from '../../../components/layout/Layout';
import { getMakecodeArcadePageRootStyle } from '../makecodeArcadePageStyles';

const Extensions: React.FC = () => {
  const navigate = useNavigate();
  const { isMobile } = useLayoutContext();

  const extensions = [
    {
      title: '코드 예제 공유',
      path: '/makecodearcade/extensions/code-examples',
      description:
        '아래 예제 코드를 활용해서 여러분들만의 게임에 적용해보세요.',
      icon: '📋'
    },
    {
      title: '이미지 변환기',
      path: '/makecodearcade/extensions/imageconverter',
      description: '이미지를 MakeCode Arcade에서 사용할 수 있는 자바스크립트 코드로 변환',
      icon: '🖼️'
    },
    {
      title: '음악 공유',
      path: '/makecodearcade/extensions/music',
      description:
        'MakeCode Arcade 음악·효과음 프로젝트를 공유 주소로 올리고, 스크린샷·소스(zip 등)를 함께 공유합니다.',
      icon: '🎵'
    }
  ];

  return (
    <MainLayout>
      <div style={getMakecodeArcadePageRootStyle(isMobile)}>
        <h1
          style={{
            margin: '0 0 16px 0',
            fontSize: '24px',
            fontWeight: 600,
            fontFamily: 'var(--font-family-primary)',
            color: 'var(--Color-text-strong)',
          }}
        >
          MakeCode Arcade 확장 기능
        </h1>
        <p
          style={{
            margin: '0 0 24px 0',
            fontSize: '14px',
            color: 'var(--Color-text-normal)',
            fontFamily: 'var(--font-family-primary)',
          }}
        >
          MakeCode Arcade에서 사용할 수 있는 다양한 확장 기능들을 제공합니다.
        </p>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: 24, marginTop: 32 }}>
          {extensions.map((extension) => (
            <div
              key={extension.path}
              onClick={() => navigate(extension.path)}
              style={{
                background: 'white',
                borderRadius: 12,
                padding: 24,
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                cursor: 'pointer',
                height: '100%',
                boxSizing: 'border-box'
              }}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
                <span style={{ fontSize: 28 }}>{extension.icon}</span>
                <span style={{ fontSize: 18, fontWeight: 600 }}>{extension.title}</span>
              </div>
              <p style={{ fontSize: 14, color: '#666', margin: 0 }}>
                {extension.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </MainLayout>
  );
};

export default Extensions;
